import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { closeModalAction } from '../../../actions/modal';
import Form from '../../../common/Form';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import Input from '../../../common/Form/Input';
import { sendAlert } from '../../../actions/utils';
import { TicketSource } from '../../Ticket/TicketController';

const formName = 'notifyEndCustomer';

export default function NotifyEndCustomer({ message, mobile, ticket_id }) {
    const defaultValues = { mobile };
    const dispatch = useDispatch();
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);
    const serviceRequestData = useSelector((state) => state.serviceRequest.serviceRequestData);

    const methods = useForm({ defaultValues, mode: 'all' });
    const setValue = methods.setValue;

    const memoizedServiceRequest = useMemo(() => {
        let s = {};
        if (ticket_id && serviceRequestData && serviceRequestData[ticket_id]) {
            s = serviceRequestData[ticket_id];

            let mobile = '';
            let name = '';
            if (s?.owner?.name) {
                name = s.owner.name;
                mobile = s.owner.mobile;
            } else if (s?.location?.owners?.length > 0) {
                name = s?.location?.owners[0].name || '';
                mobile = s?.location?.owners[0].mobile || '';
            } else if (s.source === TicketSource.IVR) {
                if (s.requester_phone_number || s.requester_name) {
                    mobile = s.requester_phone_number || '';
                    name = s.requester_name || ''
                }
            }
            if (mobile) {
                const cleanedMobile = mobile.trim().toString().replace(/\D/g, '').slice(-10);
                s.local_contact_number = cleanedMobile;
            }
        }
        return s;
    }, [serviceRequestData, ticket_id]);

    useEffect(() => {
        if (memoizedServiceRequest.local_contact_number) {
            setValue('mobile', memoizedServiceRequest.local_contact_number);
        }
    }, [memoizedServiceRequest.local_contact_number, setValue]);

    const submit = (formValues) => {
        const payload = { content: message.content, phone_number: formValues.mobile, ticket_id: message.chat_id, org_id: 'SCOGO' || memoizedServiceRequest.org_id, type: 'SEND_TICKET_UPDATES' };
        dispatch(sendAlert({ payload, formName }));
    };
    return (
        <Form
            methods={methods}
            onSubmit={submit}
            submitButtonText={'Submit'}
            onCancel={() => dispatch(closeModalAction())}
            showSubmit
            submitContainerClassName='flex gap-2 justify-end py-4 px-4'
            isLoading={formButtonLoading[formName]}
        >
            <div className='px-2'>
                <Input
                    autofocus
                    label='Mobile'
                    type={'text'}
                    name='mobile' required
                    validate={(value) => {
                        if (value === '') return true;
                        return value.toString().length === 10 || 'Invalid Mobile';
                    }}
                />
            </div>
        </Form>
    );
}
